import styled from 'styled-components';

export const NumberSpan = styled.span`
	color: gray;
	font-weight: 600;
	font-size: 35px;
`;
